import { render, staticRenderFns } from "./cadastrar.vue?vue&type=template&id=44d7519c"
import script from "./cadastrar.vue?vue&type=script&lang=js"
export * from "./cadastrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports